export const stringsKey = "TemplateListDataGridExpandedRow";
export const englishStrings = {
	recurringDailyOption: "Daily",
	recurringWeeklyOption: "Weekly",
	recurringMonthlyOption: "Monthly",
	makeRecurringToolTip: "Make Recurrence",
	viewRecurringSchedule: "View Recurrence",
	recurringWhen: "Recurring When",
	previewMessageSegmentToolTip: "Preview message",
	approximateMessageCostToolTip: "Approx Cost",
	confirmCancelAll:
		"Are you sure you want to cancel all recurrences for this message?",
	confirmCancelNext:
		"Are you sure you want to cancel the next recurrence for this message?",
	confirmCancelScheduled: "Are you sure you want to cancel this message?",
	cancelNextRunBtn: "Cancel Next Run",
	cancelAllRunsBtn: "Cancel All Recurrences",
	cancelScheduledBtn: "Cancel Message",
	closeDialogBtn: "Close",
	confirmDialogBtn: "Confirm Cancel",
	pendingTemplateMessage: "Template not yet submitted for approval",
	cancelNextSuccess: "Successfully cancelled next run of message",
	cancelAllSuccess: "Successfully cancelled all recurrences of message",
	cancelScheduledSuccess: "Successfully cancelled scheduled message",
};
